import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ICON_COLOR, ICON_HEIGHT_72, IconNG } from '../Icon'
import { PageActionsButtonAddEntity } from '../PageActionsButtonAddEntity'
import Text from '../Text'

import * as styles from './PageEmptyState.module.css'

function PageEmptyState({ EntityIcon, actions, children, className, text }) {
  const { t } = useTranslation()

  function renderAction(
    { Component = PageActionsButtonAddEntity, name, ...actionProps },
    index
  ) {
    return (
      <Fragment key={name}>
        {index > 0 ? (
          <Text isSecondary className={styles.text}>
            {t('Common.OrKey')}
          </Text>
        ) : null}
        <Component {...actionProps} />
      </Fragment>
    )
  }

  const pageEmptyStateClassName = classNames(styles.pageEmptyState, className)

  return (
    <div className={pageEmptyStateClassName}>
      {EntityIcon ? (
        <IconNG
          Icon={EntityIcon}
          className={styles.icon}
          color={ICON_COLOR.SecondaryTextColor50}
          size={ICON_HEIGHT_72}
        />
      ) : null}
      {children || (
        <Text isSecondary className={styles.text}>
          {text}
        </Text>
      )}

      {actions?.length > 0 ? (
        <div className={styles.actions}>{actions.map(renderAction)}</div>
      ) : null}
    </div>
  )
}

export default PageEmptyState
